import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PermissionAction } from "@colab/shared";

export type RoleRow = {
  id: string;
  key: string;
  name: string;
  description: string | null;
  is_system: boolean;
  permissions: PermissionAction[];
};

// GET /api/settings/roles — every role + its permission set.
export function useRoles() {
  return useQuery<RoleRow[], ApiClientError>({
    queryKey: queryKeys.settings.roles(),
    queryFn: () => apiFetch<RoleRow[]>("/settings/roles"),
  });
}
